module.exports = __webpack_public_path__ + "img/ihamac.9ac29403.png";